import { POST_FORM_LINK_ERROR } from './';

export default error => dispatch =>
  dispatch({ type: POST_FORM_LINK_ERROR, payload: { error } });
